















import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import VideoPlayer from "./VideoPlayer.vue";

@Component({
  components: {
    VideoPlayer,
  },
})
export default class VideoM3u8Demo extends Vue {
  videoOptions = {
    autoplay: false,
    controls: true,
    sources: [
      {
        type: 'application/x-mpegURL',
        src: 'https://content.jwplatform.com/manifests/yp34SRmf.m3u8',
      },
    ],
  };
}
